var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as FileSaver from 'file-saver';
import * as React from 'react';
import toCsv from './lib/csv';
var CsvDownloader = /** @class */ (function (_super) {
    __extends(CsvDownloader, _super);
    function CsvDownloader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props, suffix = _a.suffix, prefix = _a.prefix, bom = _a.bom, data = _a.data, mapping = _a.mapping, separator = _a.separator, noHeader = _a.noHeader, wrapColumnChar = _a.wrapColumnChar;
            var columns = Object.keys(mapping);
            var transform = columns.map(function (name) {
                var m = mapping[name];
                return function (x) { return String(typeof m === 'function' ? m(x) : x[m]); };
            });
            var table = data.map(function (x) { return transform.map(function (t) { return t(x); }); });
            var csv = toCsv(columns, table, separator, noHeader, '"');
            var bomCode = bom ? '\ufeff' : '';
            var filename = _this.props.filename;
            if (filename.indexOf('.csv') === -1) {
                filename += '.csv';
            }
            if (suffix) {
                filename = typeof suffix === 'string' || typeof suffix === 'number'
                    ? filename.replace('.csv', "_" + suffix + ".csv")
                    : filename.replace('.csv', "_" + (new Date()).getTime() + ".csv");
            }
            if (prefix) {
                filename = typeof prefix === 'string' || typeof prefix === 'number'
                    ? prefix + "_" + filename
                    : (new Date()).getTime() + "_" + filename;
            }
            var blob = new Blob(["" + bomCode + csv], { type: 'text/csv;charset=utf-8' });
            FileSaver.saveAs(blob, filename);
        };
        return _this;
    }
    CsvDownloader.prototype.render = function () {
        var _a = this.props, children = _a.children, text = _a.text;
        if (typeof children === 'undefined') {
            return this.props.data ?
                React.createElement("button", { onClick: this.handleClick, type: "button", "aria-label": "Download" }, text ? text : 'Download')
                : React.createElement("span", null);
        }
        return this.props.data ?
            React.createElement("div", { onClick: this.handleClick, onKeyPress: this.handleClick, role: "button", tabIndex: 0, "aria-label": "Download" }, children)
            : React.createElement("span", null);
    };
    CsvDownloader.defaultProps = {
        bom: true,
        columns: false,
        noHeader: false,
        separator: ',',
    };
    return CsvDownloader;
}(React.Component));
export { CsvDownloader };
//# sourceMappingURL=index.js.map